export interface FormatDashboardDeltaOptions {
  /** When true, append absolute count change in parentheses, e.g. `↑ 12% (3)`. */
  showAbsoluteChange?: boolean;
}

export const formatDashboardDelta = (
  current: number,
  previous: number,
  options: FormatDashboardDeltaOptions = {},
): string => {
  if (previous === 0) {
    return "—";
  }

  const delta = current - previous;
  const percent = Math.round((delta / previous) * 100);
  const arrow = percent > 0 ? "↑" : percent < 0 ? "↓" : "→";
  const absPercent = Math.abs(percent);
  let result = `${arrow} ${absPercent}%`;

  if (options.showAbsoluteChange && delta !== 0) {
    result += ` (${Math.abs(delta)})`;
  }

  return result;
};
